module.exports = __webpack_public_path__ + "static/media/2.522baacd.wav";